import React from 'react';
import PropTypes from 'prop-types';

const TextLink = (props) => {
  const { to, children, size, outgoing, withoutLink, onClick, className } = props;

  const linkProps = {};

  if (to && !withoutLink) {
    linkProps.href = to;
  }

  if (onClick) {
    linkProps.onClick = onClick;
  }

  if (outgoing) {
    linkProps.target = '_blank';
    linkProps.rel = 'noopener noreferrer';
  }

  return (
    <div className={`textLinkWrap ${onClick ? 'clickable' : ''} ${className || ''}`}>
      <a className={`textLink ${size}`} {...linkProps}>
        {children}
      </a>
    </div>
  );

};

TextLink.defaultProps = {
  size: '',
};

TextLink.propTypes = {
  to: PropTypes.string,
  children: PropTypes.node,
  size: PropTypes.string,
  outgoing: PropTypes.bool,
  withoutLink: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

export default TextLink;
